var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00011 3.00002C3.73489 3.00002 3.48054 3.10537 3.293 3.29291C3.10546 3.48044 3.00011 3.7348 3.00011 4.00002C2.99645 4.13293 3.02134 4.26508 3.07309 4.38756C3.12484 4.51004 3.20225 4.61999 3.30011 4.71002L8.57011 10L3.30011 15.28C3.20442 15.3738 3.12855 15.4859 3.07701 15.6096C3.02548 15.7332 2.99932 15.866 3.00011 16C3.00011 16.2652 3.10546 16.5196 3.293 16.7071C3.48054 16.8947 3.73489 17 4.00011 17C4.25732 16.9887 4.50203 16.8858 4.69011 16.71L10.0001 11.41L15.2501 16.67C15.4432 16.8429 15.6911 16.9421 15.9501 16.95C16.2153 16.95 16.4697 16.8447 16.6572 16.6571C16.8448 16.4696 16.9501 16.2152 16.9501 15.95C16.953 15.8196 16.9287 15.69 16.8788 15.5695C16.8288 15.449 16.7544 15.3402 16.6601 15.25L11.4001 10L16.6801 4.70002C16.7803 4.61294 16.8607 4.50541 16.9159 4.38467C16.9711 4.26393 16.9998 4.13277 17.0001 4.00002C17.0013 3.80259 16.944 3.60923 16.8354 3.44432C16.7269 3.27941 16.5719 3.15032 16.3901 3.07332C16.2083 2.99633 16.0078 2.97487 15.8138 3.01165C15.6198 3.04843 15.4411 3.14181 15.3001 3.28002L10.0001 8.58002L4.68011 3.26002C4.49416 3.09099 4.25139 2.99816 4.00011 3.00002Z",
    fill: "#004685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDel);
export default __webpack_public_path__ + "static/media/picto_del.9564e0ba392e49d0352c92ffd0095fa8.svg";
export { ForwardRef as ReactComponent };